'use strict';

 /* @name thothApp.controller:EmployeeCtrl
 * @description
/**
 * @ngdoc function
 * # EmployeeCtrl
 * Controller of the thothApp
 */
angular.module('thothApp.controllers')
  .controller('EmployeeCtrl', [function () {
  }]);
